module.exports = __webpack_public_path__ + "static/media/RCP Privacy Policy - Footer New.f7d48412.pdf";